import { Injectable } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';

export const enum Paging {
    Prev = -1,
    Next = 1
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
}

// If there is no intended action for a notification type, display an empty string.
export enum NotificationActionButtonDisplayEnum {
    Info = '',
    Survey = 'Start',
    InvoicesProcessed = 'View',
    FundsReleased = 'View',
    InvoiceDownload = 'View'
}

@Injectable({ providedIn: 'root' })
export class BankAccountTypeDisplay {
    public UNKNOWN_BANK_ACCOUNT_TYPE = this._i18n('Bank ACH');
    public ACH = this._i18n('Bank ACH');
    public WIRE = this._i18n('Wire Transfer');
    constructor(private _i18n: I18n) {}
}
